import { Component } from "react";
import * as Sentry from "@sentry/react";
import { P, FF } from "../../styles/tokens";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[Arbo ErrorBoundary]", error, info?.componentStack);
    // Este boundary envuelve a ContentRouter, o sea toda la app. Sin este
    // reporte, un crash de render era invisible en producción: el usuario veía
    // "Reintentar" y nadie se enteraba nunca.
    try {
      Sentry.captureException(error, {
        contexts: { react: { componentStack: info?.componentStack } },
        tags: { boundary: "ContentRouter" },
      });
    } catch {
      // Sentry no configurado (dev) — el console.error ya dejó rastro.
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, textAlign: "center" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: P.text, fontFamily: FF, marginBottom: 8 }}>Algo salió mal</div>
          <div style={{ fontSize: 12, color: P.textSm, fontFamily: FF, marginBottom: 16 }}>{this.state.error?.message || "Error inesperado"}</div>
          <button
            type="button"
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{ padding: "10px 20px", borderRadius: 12, border: "none", background: P.ingresos.base, color: "#fff", fontFamily: FF, fontSize: 13, fontWeight: 700, cursor: "pointer" }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
